import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { PermissionService } from 'app/security/permission';
import { ROLE } from 'app/user/roles.const';
import { NewPasswordComponent } from './new-password/new-password.component';

const routes: Routes = [
  {
    path: 'reset',
    component: EmailVerificationComponent,
    canActivate: [PermissionService],
    data: {
      only: ROLE.GUEST,
      redirectTo: ''
    }
  },
  {
    path: 'new-password/:token',
    component: NewPasswordComponent,
    canActivate: [PermissionService],
    data: {
      only: ROLE.GUEST,
      redirectTo: ''
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResetPasswordRoutingModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/reset-password/reset-password-routing.module.ts